import React from 'react';
import {useEffect} from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";
import Header from './components/Header';
import Main from './components/Main';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';
import BG from './components/images/vick.jpg';
import './components/css/style.css';


const App = () => {
   useEffect(()=>{
      Aos.init()
      Aos.refresh()
   },[])
  return (
     <section style={{background:`linear-gradient(to left,rgba(0,0,0,0.5),rgba(0,0,0,0.5)),url('${BG}')  fixed no-repeat top/cover`}} className="">
        <Header />
        <Main />
        <About />
        <Services />
        <Portfolio />
        <Contact />
        <ScrollToTop />
     </section>
  )
}

export default App
